import { RiImageLine, RiAttachmentLine } from '@remixicon/react'
import { CommentType } from 'src/components/postComments'
import { Wrapper } from './inputIcons.styles'
import { InputIconsProps } from './inputIcons.types'

const InputIcons = ({ show, allowMedias, onClick }: InputIconsProps) => {
  const icons = {
    [CommentType.DOCUMENT]: <RiAttachmentLine size={16} />,
    [CommentType.IMAGE]: <RiImageLine size={16} />
  }

  return (
    <Wrapper
      className="_text-gray-500 _d-flex _align-items-center _justify-content-center _cursor-pointer _position-absolute"
      $show={show}
    >
      {allowMedias?.map((media) => (
        <span key={media} onClick={() => onClick(media)}>
          {icons[media]}
        </span>
      ))}
    </Wrapper>
  )
}

export default InputIcons
